import React, { Component } from "react";
import Top from "./Top";
import Middle from "./Middle";
import Bottom from "./Bottom";
import "./Content.css";

export default class Content extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      config: props.config,
      breadcrumbs: props.breadcrumbs,
      middleUrl: props.middleUrl,
    };
  }

  render(props) {
    return (
      <section className="content">
        <div className="">
          <Top
            config={this.state.config}
            breadcrumbs={this.state.breadcrumbs}
          />
          <Middle
            data={this.state.data}
            data2={this.state.data2}
            config={this.state.config}
            middleUrl={this.state.middleUrl}
          />
          <Bottom />
        </div>
      </section>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/Content/Content.js